import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const kavita = defineConnector({
  identifier: "kavita",
  name: "Kavita",
  tagLine: "Self-hosted digital reading platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Kavita server URL",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://kavita.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Kavita instance.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Kavita, go to **Admin Dashboard → General** and copy the **API Key**.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/Server/server-info`,
  },
});
